module.exports = "/_next/static/images/Sources@3x-4bc60ed8315cc84ea0713e1ea835e134.webp";